/* eslint-disable react/no-unstable-nested-components */

import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';

import ForgotPassword from '../pages/ForgotPassword';
import Home from '../pages/Home';
import Login from '../pages/Login';
import Logout from '../pages/Logout';
import ResetPassword from '../pages/ResetPassword';

function Router(state) {
  const { environment } = state;

  return (
    <Switch>
      <Route exact path="/" render={(props) => <Home location={props.location} environment={environment} />} />
      <Route exact path="/login" component={() => <Login environment={environment} />} />
      <Route exact path="/logout" component={() => <Logout environment={environment} />} />
      <Route exact path="/forgotpassword" component={() => <ForgotPassword environment={environment} />} />
      <Route exact path="/resetpassword" component={() => <ResetPassword environment={environment} />} />
    </Switch>
  );
}

Router.propTypes = {
  location: PropTypes.shape({}),
};

Router.defaultProps = {
  location: null,
};

export default Router;
